import { Users } from "lucide-react";
import { StatusBadge } from "./StatusBadge";

export const TeamStatusList = ({ perTeam }) => (
  <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
    {perTeam.map((p, idx) => (
      <div key={p.team.id} data-testid={`team-status-card-${p.team.id}`} className="panel fade-up p-5" style={{ animationDelay: `${idx * 80}ms` }}>
        <div className="flex items-start justify-between gap-3">
          <div>
            <h3 className="font-display text-xl font-bold">{p.team.name} <span className="font-normal text-[color:var(--muted)]">({p.team.specialty})</span></h3>
            <div className="mt-1 flex items-center gap-1.5 text-xs text-[color:var(--muted)]"><Users className="h-3.5 w-3.5" />{p.team.members.join(", ") || "-"}</div>
          </div>
          <div className="font-mono text-xs text-amber-400">{p.doneCount}/{p.items.length}</div>
        </div>
        <ul className="mt-4 divide-y divide-[color:var(--border)]">
          {p.items.length === 0 && <li className="py-2 text-sm text-[color:var(--muted)]">No jobs assigned</li>}
          {p.items.map((i) => (
            <li key={i.id} className="flex items-center justify-between gap-2 py-2 text-sm">
              <span><span className="font-mono text-[color:var(--muted)]">{i.job.no}.</span> {i.job.name} <span className="font-mono text-xs text-[color:var(--muted)]">w{i.job.weight}</span></span>
              <StatusBadge status={i.status} />
            </li>
          ))}
        </ul>
        <div className="mt-4 h-1 w-full overflow-hidden rounded-full bg-[color:var(--border)]">
          <div className="h-full bg-amber-500 transition-[width] duration-700" style={{ width: `${p.pct}%` }} />
        </div>
        <div className="mt-2 text-xs italic text-[color:var(--muted)]">Team progress: {p.doneCount} of {p.items.length} done</div>
      </div>
    ))}
  </div>
);
